import { render, staticRenderFns } from "./entity-optin.vue?vue&type=template&id=b646a658&scoped=true"
import script from "./entity-optin.vue?vue&type=script&lang=js"
export * from "./entity-optin.vue?vue&type=script&lang=js"
import style0 from "./entity-optin.vue?vue&type=style&index=0&id=b646a658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b646a658",
  null
  
)

export default component.exports